module.exports = __webpack_public_path__ + "img/mbr-dots.66feb5a2.svg";